import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import styled from 'styled-components'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Web2Services from './pages/Web2Services'
import Web3Services from './pages/Web3Services'
import About from './pages/About'
import Contact from './pages/Contact'
import MouseDot from './components/MouseDot'

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const Main = styled.main`
  flex-grow: 1;
`

const Layout = ({ children }) => (
  <AppWrapper>
    <Navbar />
    <Main>{children}</Main>
    <Footer />
  </AppWrapper>
)

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout><Home /></Layout>
  },
  {
    path: '/web2-services',
    element: <Layout><Web2Services /></Layout>
  },
  {
    path: '/web3-services',
    element: <Layout><Web3Services /></Layout>
  },
  {
    path: '/about',
    element: <Layout><About /></Layout>
  },
  {
    path: '/contact',
    element: <Layout><Contact /></Layout>
  }
])

function App() {
  return (
    <>
      <MouseDot />
      <RouterProvider router={router} />
    </>
  );
}

export default App
